import axios from 'axios';
import type { Site } from '@hotjar/site';
import { isAllowed } from '@hotjar/feature-flags';
import type { ToolType, ToolCountResult } from './ToolsCountResult';

export const getToolsCount = async <T extends ToolType>(
  site: Site,
  toolType: T,
): Promise<ToolCountResult<T>> => {
  const separateAskServicePrefix = isAllowed('ask.separate_service', site) ? 'ask/' : '';
  const result = await axios.get<ToolCountResult<T>>(
    `/api/${separateAskServicePrefix}v1/sites/${site.id}/tools-count`,
    {
      params:
        toolType === 'all'
          ? undefined
          : { fields: toolType === 'feedback' ? 'n_incoming_feedback' : 'n_polls' },
    },
  );

  return result.data;
};
